module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921015649_T.8e95852d.jpg";